import RegisterAuth from 'modules/auth/Register'

const AccountTypeSelect = () => {
  return <RegisterAuth />
};

export default AccountTypeSelect;